import type { Automation } from '../automations/automation'
import type { AutomationSourceEnum } from '../automations/automation-source.enum'

export class AutomationGroup {
    automationGroupId: string
    companyId: string
    createdAt: Date
    updatedAt?: Date
    source: AutomationSourceEnum
    label: string
    audienceId: string
    repeat: number
    status: number
    automation?: Automation[]
}
